
// `x-charts-vendor/flatqueue` (CommonJS)
// See upstream license: git+https://github.com/mourner/flatqueue/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("./lib/flatqueue");
